export default "__VITE_ASSET__BkYWVfW8__"